import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

const ReactIcon = ({ color = '#FFF', size = '14px', ...props }) => (
  <svg
    viewBox="0 0 20 21"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.074 0c5.525 0 10.005 4.475 10.005 10s-4.48 10-10.005 10S.079 15.525.079 10s4.47-10 9.995-10Zm.005 2c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8Zm5.105 10c-.8 2.045-2.775 3.5-5.105 3.5-2.33 0-4.305-1.455-5.105-3.5ZM6.579 6c.83 0 1.5.67 1.5 1.5S7.409 9 6.579 9s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5Zm7 0c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5Z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

ReactIcon.propTypes = propTypes;

export default ReactIcon;
